// Auto-generated via protoc–do not edit this file directly.
import { makeRequest } from '@mc/networking/autolyse';
type RequestOptions = {
  headers?: Record<string, string>;
};
type UnknownProtoField = any;
export type GetTranslationsRequest = {
  locale: string;
  appVersion: string;
};
export type GetTranslationsResponse = {
  translations: Record<string, string>;
};
export function GetTranslations(
  request: GetTranslationsRequest,
  opts?: RequestOptions,
): Promise<GetTranslationsResponse> {
  return makeRequest(
    '/mailchimp.i18n.v1.I18nService/GetTranslations',
    request,
    opts,
  );
}
